module.exports = __webpack_public_path__ + "static/media/Z12.b38826f8.jpg";